import { memo } from 'react';
import { difference } from 'lodash-es';
import { useMultiSuggestCoverage } from '@lp/features/MultiSuggest/hooks';
import { StatisticsListProps } from './StatisticsList';
import { StatisticsItem } from './StatisticsItem';

type CoverageDetailsProps = StatisticsListProps & {
  isOverallStatistics?: boolean;
};

export const CoverageDetails = memo(
  ({ taskId, caseIds, logisticsIds, chainNumber, isOverallStatistics = false }: CoverageDetailsProps) => {
    const { coverageItems, isLoading } = useMultiSuggestCoverage({
      taskId,
      caseIds,
      logisticsIds,
      chainNumber,
      isOverallStatistics,
    });

    if (isLoading || !coverageItems.length) return null;

    return (
      <div className="flex flex-col gap-3">
        <span className="text-m-cps text-base-20">COVERAGE</span>
        {coverageItems.map((data) => (
          <StatisticsItem key={data.type} data={data} />
        ))}
      </div>
    );
  },
  (prev, next) => {
    const areCaseIdsEqual = !difference(prev.caseIds, next.caseIds).length;
    const areLogisticsIdsEqual = !difference(prev.logisticsIds, next.logisticsIds).length;
    const isChainNumberEqual = prev.chainNumber === next.chainNumber;

    return areCaseIdsEqual && areLogisticsIdsEqual && isChainNumberEqual;
  },
);
